import { c as _c } from "react/compiler-runtime";
import React from 'react';
import useAutoCaptureDoc from './hooks/use-auto-capture-doc';
import type { CaptureStatus, Resolution, VideoRef } from './types';
export type AutoCaptureDocProps = {
  canvasAutoCaptureRef: React.MutableRefObject<HTMLCanvasElement | undefined>;
  feedbackPositionFromBottom: number;
  isCaptured: boolean;
  videoResolution: Resolution | undefined;
  onDetectionComplete: () => void;
  onDetectionReset: () => void;
  outlineHeight: number;
  outlineWidth: number;
  setAutoCaptureFeedback: (x?: CaptureStatus) => void;
  videoRef: VideoRef;
  videoSize: Resolution | undefined;
};
const AutoCaptureDoc = t0 => {
  const $ = _c(12);
  const {
    canvasAutoCaptureRef,
    feedbackPositionFromBottom,
    isCaptured,
    videoResolution,
    onDetectionComplete,
    onDetectionReset,
    outlineHeight,
    outlineWidth,
    setAutoCaptureFeedback,
    videoRef,
    videoSize
  } = t0;
  const t1 = -feedbackPositionFromBottom / 2;
  let t2;
  if ($[0] !== canvasAutoCaptureRef || $[1] !== isCaptured || $[2] !== onDetectionComplete || $[3] !== onDetectionReset || $[4] !== outlineHeight || $[5] !== outlineWidth || $[6] !== setAutoCaptureFeedback || $[7] !== t1 || $[8] !== videoRef || $[9] !== videoResolution || $[10] !== videoSize) {
    t2 = {
      canvasRef: canvasAutoCaptureRef,
      isCaptured,
      videoResolution,
      onDetectionComplete,
      onDetectionReset,
      onStatusChange: setAutoCaptureFeedback,
      outlineHeight,
      outlineOffsetY: t1,
      outlineWidth,
      videoRef,
      videoSize
    };
    $[0] = canvasAutoCaptureRef;
    $[1] = isCaptured;
    $[2] = onDetectionComplete;
    $[3] = onDetectionReset;
    $[4] = outlineHeight;
    $[5] = outlineWidth;
    $[6] = setAutoCaptureFeedback;
    $[7] = t1;
    $[8] = videoRef;
    $[9] = videoResolution;
    $[10] = videoSize;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  useAutoCaptureDoc(t2);
  return null;
};
export default React.memo(AutoCaptureDoc);